import React, { useState, lazy } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
const images = [{
  src: 'https://cdn.magicpatterns.com/uploads/mHVgw9s4dvc7ZNg4SyCCbX/IMG-20260510-WA0027.jpg',
  caption: 'Christ Love at Christmas — Orphanage Outreach'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/f1R2Vny6zLJmaijCMSyGae/IMG-20260510-WA0031.jpg',
  caption: 'Hospital Outreach — Christ Medical Center'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/kZrAiEzTqMexLKrw7mfDaQ/IMG-20260510-WA0028.jpg',
  caption: 'Ajebor Orphanage Home Visit'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/9LCvC9itFaKE48VpCiXSmL/IMG-20260510-WA0026.jpg',
  caption: 'Zimran Medical Centre Outreach'
}];
export function Gallery() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);
  return <section className="py-32 bg-ivory text-midnight" data-id="element-175" data-mp="26upxsup65tjm">
      <div className="max-w-7xl mx-auto px-6" data-id="element-176" data-mp="21x6irskndcqm">
        <div className="text-center mb-16" data-id="element-177" data-mp="rckq7b82tycc">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-midnight/5 rounded-full text-xs font-bold tracking-widest uppercase mb-6" data-id="element-178" data-mp="rbi2td9yqe16">
            Gallery
          </div>
          <h3 className="text-5xl md:text-7xl font-display font-bold tracking-tighter" data-id="element-179" data-mp="111ulezy7vx4o">
            Faith in{' '}
            <span className="font-serif italic font-medium text-gold" data-id="element-180" data-mp="152wlfizykd7p">
              Action
            </span>
          </h3>
          <p className="mt-6 text-lg text-charcoal/70 font-medium max-w-2xl mx-auto" data-id="element-181" data-mp="8fjj9kuypo5r">
            Glimpses from our outreaches, visits, and community impact across
            Benin City and beyond.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6" data-id="element-182" data-mp="hgq05v1ix0zj">
          {images.map((img, i) => <motion.button key={img.src} type="button" onClick={() => setOpenIdx(i)} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className={`group relative overflow-hidden rounded-[2rem] bg-midnight/5 shadow-sm hover:shadow-xl transition-all duration-500 ${i === 0 ? 'col-span-2 row-span-2 aspect-square md:aspect-auto' : 'aspect-square'} ${i % 2 === 0 ? 'rotate-1 hover:rotate-0' : '-rotate-1 hover:rotate-0'}`} data-id="element-183" data-mp="1stsjgxv0c4ne" data-mpi={i}>
              <img src={img.src} alt={img.caption} loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-700 ease-out" data-id="element-184" data-mp="3kvv9pr4n3yst" />
              <div className="absolute inset-0 bg-gradient-to-t from-midnight/80 via-midnight/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-185" data-mp="2newjufe7gzgd" />
              <div className="absolute bottom-0 left-0 right-0 p-6 translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500" data-id="element-186" data-mp="17on5jnnjtxuo">
                <p className="text-ivory text-sm md:text-base font-serif italic text-left" data-id="element-187" data-mp="xyk7va5hfvq0">
                  {img.caption}
                </p>
              </div>
            </motion.button>)}
        </div>
      </div>

      {/* Lightbox */}
      <AnimatePresence data-id="element-188" data-mp="1qmpqnrcz7an7">
        {openIdx !== null && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-[100] bg-midnight/95 backdrop-blur-md flex items-center justify-center p-6" onClick={() => setOpenIdx(null)} role="dialog" aria-modal="true" data-id="element-189" data-mp="1cnqaz97fy636">
            <button onClick={() => setOpenIdx(null)} aria-label="Close" className="absolute top-6 right-6 w-12 h-12 rounded-full bg-white/10 hover:bg-white/20 text-ivory flex items-center justify-center transition-colors" data-id="element-190" data-mp="lim40lkvirrz">
              <X className="w-6 h-6" data-id="element-191" data-mp="7qo1itlo3u4s" />
            </button>
            <motion.div initial={{
          scale: 0.9,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} exit={{
          scale: 0.9,
          opacity: 0
        }} transition={{
          type: 'spring',
          damping: 25,
          stiffness: 300
        }} className="max-w-5xl w-full relative" onClick={e => e.stopPropagation()} data-id="element-192" data-mp="14fx2i3yolh6d">
              <div className="bg-white p-4 rounded-[2rem] shadow-2xl rotate-1" data-id="element-193" data-mp="3b51wlf9wsx2x">
                <img src={images[openIdx].src} alt={images[openIdx].caption} className="w-full max-h-[75vh] object-contain rounded-2xl bg-midnight" data-id="element-194" data-mp="1qplxve7fgrun" />
                <p className="text-midnight text-center mt-6 mb-2 font-serif italic text-xl" data-id="element-195" data-mp="1znpjeaiexomg">
                  {images[openIdx].caption}
                </p>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </section>;
}